"use client";

import React from "react";
import { Wrench, Network, Globe, Wifi, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Media Partnership",
  description: "Kolaborasi konten strategis dan pertukaran aset media untuk memperluas jangkauan audiens secara eksklusif melalui jaringan distribusi kami.",
  icon: Wrench,
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/partner_logo_microsoft.png",
  span: "md:col-span-7 lg:col-span-6"
}, {
  title: "Publikasi Berita",
  description: "Layanan penerbitan rilis pers dan artikel jurnalistik dengan standar profesional tinggi untuk memastikan kredibilitas informasi organisasi Anda.",
  icon: Network,
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/partner_logo_cisco.png",
  span: "md:col-span-5 lg:col-span-6"
}, {
  title: "Aktivasi Event",
  description: "Dukungan publikasi dan dokumentasi komprehensif untuk memaksimalkan eksposur kegiatan dan acara penting bagi publik luas.",
  icon: Globe,
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/partner_logo_wordpress.png",
  span: "md:col-span-5 lg:col-span-6"
}, {
  title: "Penguatan Branding",
  description: "Strategi peningkatan citra melalui penempatan konten strategis dan pengelolaan identitas visual yang konsisten di seluruh kanal media.",
  icon: Wifi,
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/partner_logo_ubiquiti.png",
  span: "md:col-span-7 lg:col-span-6"
}];
export default function KeyServices() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="107654" id="kerjasama-explanation" className="py-24 bg-background relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(hsl(var(--primary)/0.05)_1px,transparent_1px)] [background-size:32px_32px] opacity-20 pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 max-w-[1280px] relative z-10">
        <div ref={headerRef} className={cn("max-w-2xl mb-16 transition-all duration-700 ease-out", isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 tracking-tight">
            Model Kerjasama Strategis
          </h2>
          <p className="text-[16px] sm:text-[14px] md:text-[16px] lg:text-[18px] text-[#4A3728] font-sans">
            Kami menawarkan berbagai bentuk kemitraan profesional untuk memperkuat jangkauan dan dampak publikasi Anda di era digital.
          </p>
        </div>

        <div ref={gridRef} className={cn("grid grid-cols-1 md:grid-cols-12 lg:grid-cols-12 gap-6 md:gap-8 lg:gap-10 transition-all duration-1000 ease-out delay-200", isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} className={cn("col-span-12", service.span)}>
                <Card className="h-full border-none border-l md:border-l border-[#F2F2F2] bg-transparent transition-all duration-300 group flex flex-col overflow-hidden">
                  <CardHeader className="px-6 md:px-8 py-4 md:py-6 lg:py-8">
                    <Icon className="w-7 h-7 md:w-9 md:h-9 lg:w-11 lg:h-11 text-[#EB7C2D] mb-5 transition-transform duration-300 group-hover:scale-110" strokeWidth={1.5} />
                    <CardTitle className="text-[24px] font-sans font-bold text-foreground tracking-tight">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="px-6 md:px-8 flex-grow">
                    <p className="text-[16px] font-sans leading-[1.6] text-[#4A3728]">
                      {service.description}
                    </p>
                  </CardContent>
                  <CardFooter className="px-6 md:px-8 py-4 md:py-6 lg:py-8 flex justify-center items-center border-t border-[#F2F2F2] mt-6 bg-transparent">
                    <img src={service.logo} alt={`${service.title} partner technology`} className="h-7 md:h-9 lg:h-11 object-contain grayscale opacity-40 transition-all duration-500 group-hover:grayscale-0 group-hover:opacity-80" />
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>

        <div className="mt-16 flex justify-center">
          <Button variant="outline" className="border-[#EB7C2D] text-[#EB7C2D] hover:bg-[#EB7C2D] hover:text-white px-8 h-12 text-[15px] font-medium group transition-colors duration-300" asChild>
            <Link to="/SendNewsPage">
              Lihat Detail Kerjasama
              <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}